module.exports = __webpack_public_path__ + "static/award7-f2094a24d9a0f0416220d5ca8e012af3.png";